module.exports = __webpack_public_path__ + "static/media/main_menu_install.4b6482df.svg";